'use client';

import { c as _c } from "react/compiler-runtime";
export const Stamp = props => {
  const $ = _c(2);
  if (!props.text) {
    return null;
  }
  let t0;
  if ($[0] !== props.text) {
    t0 = <div className="rounded-[4px] bg-bodi-accent-bright-500 px-1 font-sans text-body-xs leading-5 font-semibold text-bodi-black-text">{props.text}</div>;
    $[0] = props.text;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};